import { render, staticRenderFns } from "./e-language-switcher.vue?vue&type=template&id=5def12ec&scoped=true&lang=pug&"
import script from "./e-language-switcher.vue?vue&type=script&lang=js&"
export * from "./e-language-switcher.vue?vue&type=script&lang=js&"
import style0 from "./e-language-switcher.vue?vue&type=style&index=0&id=5def12ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5def12ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
